/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid, IconButton, Paper, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Vocabulary } from "../../Utils/Vocabulary";
type DeviceDetailsProps = {
  details: any;
  title?: string;
  onDelete?: () => void;
  handleChangeDeviceDetailsValue: (key: string, value: string | any) => void;
};
export default function DeviceDetails(props: DeviceDetailsProps) {
  const { details, title, onDelete, handleChangeDeviceDetailsValue } = props;

  if (!details) return null;

  const deviceDetails = Object.entries(details);

  const fields = (
    <Grid container spacing={2} style={{ margin: 10 }}>
      {deviceDetails.map((detail, index) => (
        <Grid
          key={`detail_${detail[1]}_${index}`}
          item
          xs={6}
          md={3}
          lg={3}
          style={{ fontSize: "15px" }}
        >
          <TextField
            type="text"
            name={detail[0]}
            label={Vocabulary[detail[0]]}
            variant="standard"
            fullWidth
            value={detail[1]}
            onChange={(e) =>
              handleChangeDeviceDetailsValue(detail[0], e.target.value)
            }
          />
        </Grid>
      ))}
    </Grid>
  );

  if (title) {
    return (
      <Grid item xs={12} md={12} lg={12} style={{ margin: 10 }}>
        <Paper style={{ padding: 15 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <h3 style={{ marginTop: 0, marginBottom: 0 }}>{title}</h3>
            {onDelete && (
              <IconButton onClick={onDelete} size="small" color="error">
                <DeleteIcon />
              </IconButton>
            )}
          </div>
          {fields}
        </Paper>
      </Grid>
    );
  }

  return fields;
}
